import useSWR from "swr";
import fetcher from "./fetcher";
import { termsHtml } from "../domain/sendin";
import { useMemo } from "react";

export default function useSendinGuidelines(influencerId) {
  const { data, error } = useSWR(
    influencerId ? `/api/influencer/sendinGuidelines/${influencerId}` : null,
    fetcher,
  );

  const guidelinesHtml = useMemo(() => {
    if (!data?.guidelinesHtml) {
      return termsHtml;
    }
    return data.guidelinesHtml;
  }, [data]);

  return {
    guidelinesHtml,
    isLoading: !data && !error && Boolean(influencerId),
    isError: Boolean(error),
  };
}
